/* Blackeyz : global.js (vanilla, différé, sans dépendance) */
(() => {
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const theme = window.theme || { routes: {}, strings: {}, cartType: 'drawer' };
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.body.classList.contains('no-motion');

  /* ---------- Animation « preuve par le signal » ---------- */
  if (!reducedMotion && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        if (!el.hasAttribute('data-loop')) {
          io.unobserve(el);
          el.classList.add('is-armed');
          requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-playing')));
          setTimeout(() => el.classList.remove('is-armed', 'is-playing'), 3200);
          return;
        }
        if (el.signalRunning) return;
        // Boucle : étui ouvert (0 %), fermeture et clic (100 %), pause fermé, réouverture.
        el.signalRunning = true;
        const pauseOpen = Number(el.dataset.pauseOpen) || 2000;
        const pauseClosed = Number(el.dataset.pauseClosed) || 2500;
        el.classList.add('is-instant');
        const cycle = () => {
          el.classList.add('is-armed');
          requestAnimationFrame(() => requestAnimationFrame(() => el.classList.remove('is-instant')));
          setTimeout(() => {
            el.classList.add('is-playing');
            setTimeout(() => {
              el.classList.remove('is-armed', 'is-playing');
              setTimeout(() => (el.signalVisible ? cycle() : (el.signalRunning = false)), pauseClosed);
            }, 2600);
          }, pauseOpen);
        };
        cycle();
      });
    }, { threshold: 0.35 });
    const seen = new IntersectionObserver((entries) => entries.forEach((e) => { e.target.signalVisible = e.isIntersecting; }));
    $$('.js-signal[data-loop]').forEach((el) => seen.observe(el));
    $$('.js-signal').forEach((el) => io.observe(el));
  }

  /* ---------- Tiroir panier ---------- */
  const drawer = $('[data-cart-drawer]');
  let lastFocus = null;

  const openDrawer = () => {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    const panel = $('.drawer__panel', drawer);
    if (panel) panel.focus();
    loadCartReco();
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    if (lastFocus) lastFocus.focus();
  };

  const updateCount = (count) => {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = Number(count) === 0;
    });
  };

  const renderDrawer = (sections) => {
    if (!sections || !sections['cart-drawer'] || !drawer) return;
    const target = $('#shopify-section-cart-drawer', drawer);
    if (!target) return;
    const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    const fresh = doc.querySelector('#shopify-section-cart-drawer');
    target.innerHTML = fresh ? fresh.innerHTML : sections['cart-drawer'];
    const countEl = $('[data-cart-count-value]', target);
    if (countEl) updateCount(countEl.dataset.cartCountValue);
  };

  async function loadCartReco() {
    const box = drawer && $('[data-cart-reco]', drawer);
    if (!box || box.dataset.loaded || !box.dataset.productId || !theme.routes.recommendations) return;
    box.dataset.loaded = 'true';
    try {
      const url = `${theme.routes.recommendations}?product_id=${box.dataset.productId}&limit=1&intent=complementary&section_id=cart-reco`;
      const html = await (await fetch(url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const item = doc.querySelector('.cart-reco');
      if (item) box.replaceChildren(item);
    } catch (e) { /* suggestion facultative */ }
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && drawer && theme.cartType === 'drawer') {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-drawer-close]')) closeDrawer();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.classList.contains('is-open')) closeDrawer();
    $$('details[open][data-menu-drawer]').forEach((d) => d.removeAttribute('open'));
  });

  /* ---------- Menu du header : bascule en tiroir si les liens ne tiennent pas sur une ligne ---------- */
  $$('[data-header]').forEach((header) => {
    const nav = $('.header__nav', header);
    if (!nav) return;
    const fit = () => {
      header.classList.remove('header--compact');
      if (getComputedStyle(nav).display === 'none') return;
      if ($('ul', nav).scrollWidth > nav.clientWidth + 1) header.classList.add('header--compact');
    };
    fit();
    if ('ResizeObserver' in window) new ResizeObserver(fit).observe(header);
    if (document.fonts) document.fonts.ready.then(fit);
  });

  /* ---------- Ajout au panier (tous les formulaires produit) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form.js-product-form');
    if (!form || theme.cartType !== 'drawer' || !drawer || !window.fetch) return;
    e.preventDefault();
    const button = $('[data-add-button]', form) || (form.id && document.querySelector(`[form="${form.id}"][type="submit"]`));
    const message = $('[data-form-message]', form);
    if (button) { button.setAttribute('aria-busy', 'true'); button.disabled = true; }
    const body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);
    try {
      const res = await fetch(theme.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || theme.strings.error);
      if (message) message.hidden = true;
      renderDrawer(data.sections);
      openDrawer();
    } catch (err) {
      if (message) { message.textContent = err.message; message.hidden = false; }
    } finally {
      if (button) { button.removeAttribute('aria-busy'); button.disabled = false; }
    }
  });

  /* ---------- Modification des lignes du tiroir ---------- */
  const changeLine = async (line, quantity) => {
    try {
      const res = await fetch(theme.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)), sections: ['cart-drawer'] })
      });
      const data = await res.json();
      renderDrawer(data.sections);
    } catch (e) { /* noop */ }
  };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-line][data-line-qty]');
    if (btn) changeLine(btn.dataset.line, btn.dataset.lineQty);
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-input]');
    if (input) changeLine(input.dataset.lineInput, input.value);
  });

  /* ---------- Sélecteur de variantes ---------- */
  $$('[data-buybox]').forEach((box) => {
    const jsonEl = $('[data-variants]', box);
    if (!jsonEl) return;
    let variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    const sectionId = box.dataset.section;
    const form = document.getElementById(`ProductForm-${sectionId}`);
    const idInput = form && $('[data-variant-id]', form);
    const addBtn = form && $('[data-add-button]', form);
    const addLabel = form && $('[data-add-label]', form);
    const priceInLabel = addLabel && addLabel.textContent.includes('·');
    const gallery = box.parentElement && $('[data-gallery]', box.parentElement);
    const sticky = $('[data-sticky-price]');

    box.addEventListener('change', (e) => {
      const input = e.target.closest('[data-option]');
      if (!input) return;
      const fieldset = input.closest('fieldset');
      const label = fieldset && $('[data-selected-label]', fieldset);
      if (label) label.textContent = input.value;

      const selected = [];
      $$('[data-option]:checked', box).forEach((el) => { selected[Number(el.dataset.option)] = el.value; });
      const variant = variants.find((v) => v.options.every((o, i) => selected[i] === undefined || o === selected[i]));
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = theme.strings.unavailable;
        return;
      }
      if (idInput) idInput.value = variant.id;
      const includedInput = form && $('[data-included]', form);
      if (includedInput) { includedInput.value = variant.included || ''; includedInput.disabled = !variant.included; }
      $$('[data-pack-offer]', box).forEach((el) => { el.hidden = el.dataset.packOffer !== String(variant.id); });
      const price = $('[data-price]', box);
      if (price) price.textContent = variant.price;
      const compare = $('[data-compare]', box);
      if (compare) { compare.textContent = variant.compare || ''; compare.hidden = !variant.compare; }
      const save = $('[data-save]', box);
      if (save) { save.hidden = !variant.save; const amount = $('[data-save-amount]', save); if (amount) amount.textContent = variant.save || ''; }
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? `${theme.strings.addToCart}${priceInLabel ? ` · ${variant.price}` : ''}` : theme.strings.soldOut;
      if (sticky) sticky.textContent = variant.price;
      const stickyBtn = $('[data-sticky-atc] button');
      if (stickyBtn) stickyBtn.disabled = !variant.available;
      const discount = gallery && $('[data-discount]', gallery);
      if (discount) { discount.hidden = !variant.pct; discount.textContent = variant.pct ? (theme.strings.discountBadge || '-__PCT__%').replace('__PCT__', variant.pct) : ''; }
      $$('.pack', box).forEach((pack) => {
        const packInput = $('[data-option]', pack);
        const priceEl = $('[data-pack-price]', pack);
        if (!packInput || !priceEl) return;
        const opts = selected.slice();
        opts[Number(packInput.dataset.option)] = packInput.value;
        const match = variants.find((v) => v.options.every((o, i) => opts[i] === undefined || o === opts[i]));
        if (match) priceEl.innerHTML = `${match.compare ? `<s>${match.compare}</s>` : ''}${match.price}`;
        pack.style.opacity = match && match.available ? '' : '.45';
      });
      if (variant.media && gallery) {
        const thumb = $(`[data-media-id="${variant.media}"]`, gallery);
        if (thumb) thumb.click();
      }
      if (box.dataset.url && document.body.classList.contains('template-product')) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    });
  });

  /* ---------- Galerie produit ---------- */
  document.addEventListener('click', (e) => {
    const arrow = e.target.closest('[data-gallery] [data-gallery-step]');
    if (!arrow) return;
    const thumbs = $$('[data-media-id]', arrow.closest('[data-gallery]'));
    if (!thumbs.length) return;
    const current = Math.max(0, thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true'));
    const next = current + Number(arrow.dataset.galleryStep);
    if (next < 0 || next >= thumbs.length) return; // s'arrête à la première et à la dernière image
    thumbs[next].click();
  });
  // Flèche précédente masquée sur la 1re image, flèche suivante masquée sur la dernière
  const updateArrows = (gallery) => {
    const thumbs = $$('[data-media-id]', gallery);
    const current = Math.max(0, thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true'));
    $$('[data-gallery-step]', gallery).forEach((a) => {
      const step = Number(a.dataset.galleryStep);
      a.disabled = step < 0 ? current === 0 : current === thumbs.length - 1;
    });
  };
  $$('[data-gallery]').forEach(updateArrows);
  // Précharge les images voisines : la flèche affiche l'image suivante dès le 1er clic, même sur réseau lent
  const preloadAround = (gallery) => {
    const thumbs = $$('[data-media-id]', gallery);
    const main = $('[data-main-image]', gallery);
    if (!thumbs.length || !main) return;
    const current = Math.max(0, thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true'));
    [current + 1, current - 1].forEach((i) => {
      const t = thumbs[(i + thumbs.length) % thumbs.length];
      if (!t || t.dataset.preloaded) return;
      const img = new Image();
      img.sizes = main.sizes;
      img.srcset = t.dataset.srcset;
      img.src = t.dataset.src;
      t.dataset.preloaded = '1';
    });
  };
  const preloadAll = () => $$('[data-gallery]').forEach(preloadAround);
  if (document.readyState === 'complete') preloadAll(); else window.addEventListener('load', preloadAll);
  document.addEventListener('click', (e) => {
    const g = e.target.closest('[data-gallery]');
    if (g) setTimeout(() => { preloadAround(g); updateArrows(g); }, 0);
  });
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-gallery] [data-media-id]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-gallery]');
    const main = $('[data-main-image]', gallery);
    if (main) {
      main.removeAttribute('loading');
      main.srcset = thumb.dataset.srcset;
      main.src = thumb.dataset.src;
      main.alt = thumb.dataset.alt;
      // Petit fondu pour que le changement se voie, et image remontée dans l'écran si elle en sort (mobile)
      if (main.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        main.animate([{ opacity: 0.35 }, { opacity: 1 }], { duration: 260, easing: 'ease-out' });
      }
      const frame = $('[data-gallery-main]', gallery) || main;
      const r = frame.getBoundingClientRect();
      if (e.isTrusted && (r.top < 0 || r.bottom > window.innerHeight)) {
        frame.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    $$('[data-media-id]', gallery).forEach((t) => t.removeAttribute('aria-current'));
    thumb.setAttribute('aria-current', 'true');
    // Ligne de vignettes qui défile : ramène la vignette active dans la zone visible, sans bouger la page
    const row = thumb.closest('[data-gallery-thumbs]');
    if (row && row.scrollWidth > row.clientWidth) {
      const item = thumb.parentElement;
      const left = item.offsetLeft - row.offsetLeft;
      if (left < row.scrollLeft || left + item.offsetWidth > row.scrollLeft + row.clientWidth) {
        row.scrollTo({ left: left - (row.clientWidth - item.offsetWidth) / 2, behavior: 'smooth' });
      }
    }
  });

  /* ---------- Quantité ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.qty [data-qty]');
    if (!btn) return;
    const input = $('input', btn.closest('.qty'));
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(btn.dataset.qty));
  });

  /* ---------- Barre d'achat collante ---------- */
  const stickyBar = $('[data-sticky-atc]');
  const mainAdd = $('.product-page [data-add-button]');
  if (stickyBar && mainAdd && 'IntersectionObserver' in window) {
    stickyBar.hidden = false;
    new IntersectionObserver(([entry]) => {
      stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(mainAdd);
  }

  /* ---------- Avis : filtre par marque ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-review-filter]');
    if (!btn) return;
    const root = btn.closest('[data-reviews]');
    const value = btn.dataset.reviewFilter;
    $$('[data-review-filter]', root).forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
    $$('[data-car-brand]', root).forEach((r) => { r.hidden = Boolean(value) && r.dataset.carBrand !== value; });
  });

  /* ---------- Avis : liste déroulante des marques ---------- */
  document.addEventListener('change', (e) => {
    const select = e.target.closest('[data-review-select]');
    if (!select) return;
    const root = select.closest('[data-reviews]');
    const list = $('.reviews__list', root);
    if (!list) return;
    const value = select.value;
    const max = Number(list.dataset.max) || Infinity;
    const unique = list.hasAttribute('data-unique');
    const uniqueTitles = list.hasAttribute('data-unique-titles');
    const names = new Set();
    const titles = new Set();
    let shown = 0;
    $$('[data-car-brand]', list).forEach((card) => {
      let show = card.hasAttribute('data-default');
      if (value) {
        show = card.dataset.carBrand === value && shown < max && !(unique && names.has(card.dataset.name)) && !(uniqueTitles && card.dataset.title && titles.has(card.dataset.title));
        if (show) { names.add(card.dataset.name); titles.add(card.dataset.title); shown += 1; }
      }
      card.hidden = !show;
    });
    list.toggleAttribute('data-filtered', Boolean(value));
  });

  /* ---------- Newsletter : centres d'intérêt en tags ---------- */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form.js-newsletter');
    if (!form) return;
    const tags = ['newsletter', ...$$('[data-topic]:checked', form).map((c) => c.value)];
    const hidden = $('[data-tags]', form);
    if (hidden) hidden.value = tags.join(',');
  });

  /* ---------- Collection : tri et filtres automatiques ---------- */
  document.addEventListener('change', (e) => {
    const form = e.target.closest('[data-facets]');
    if (form) form.submit();
  });

  /* ---------- Pied de page : menus ouverts sur ordinateur ---------- */
  const desktop = window.matchMedia('(min-width: 990px)');
  const syncFooter = () => $$('[data-footer-menu]').forEach((d) => { d.open = desktop.matches; });
  syncFooter();
  desktop.addEventListener('change', syncFooter);

  /* ---------- Menu mobile ---------- */
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-menu-close]')) {
      const d = e.target.closest('details');
      if (d) d.removeAttribute('open');
    }
  });

  /* ---------- Vidéo en façade (chargée au clic) ---------- */
  if (!customElements.get('video-facade')) {
    customElements.define('video-facade', class extends HTMLElement {
      connectedCallback() {
        const btn = this.querySelector('.video__play');
        const tpl = this.querySelector('template');
        if (!btn || !tpl) return;
        btn.addEventListener('click', () => {
          this.appendChild(tpl.content.cloneNode(true));
          btn.remove();
          const poster = this.querySelector('.video__poster');
          if (poster) poster.remove();
          const media = this.querySelector('video, iframe');
          if (media && media.play) media.play().catch(() => {});
        }, { once: true });
      }
    });
  }

  /* ---------- Recommandations produit (chargées à l'affichage) ---------- */
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.url || this.children.length) return;
        const load = async () => {
          const html = await (await fetch(this.dataset.url)).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('product-recommendations');
          if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
        };
        new IntersectionObserver((entries, obs) => {
          if (entries[0].isIntersecting) { obs.disconnect(); load().catch(() => {}); }
        }, { rootMargin: '0px 0px 400px 0px' }).observe(this);
      }
    });
  }
})();
